'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PrefetchData = _ref => {
  let {
    children,
    onLoad
  } = _ref;
  const {
    loading: themeLoading
  } = nthHookTheme.useThemeX();
  const {
    loading: translationsLoading,
    translations
  } = nthHookTranslations.useTranslationsX();
  const {
    loading: settingsLoading,
    settings
  } = nthHookSettings.useSettingsX();
  if (translationsLoading || themeLoading || settingsLoading) return null;
  onLoad({
    translations,
    settings
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
var PrefetchData$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(nthHookSettings.withSettingsProvider(PrefetchData, {
  settingsRequested: `
        availableClaimTypeOptions
        claimTypeOptionActions {
          ItemMissing {
            actionType
            redirectUrl
          }
          ItemDamaged {
            actionType
            redirectUrl
          }
          PackageMissing {
            actionType
            redirectUrl
          }
          WrongItem {
            actionType
            redirectUrl
          }
        }
      `
}), {
  themeTokens: ['bodytextDefaultNone', 'buttonsPrimaryDefault', 'buttonsPrimaryDisabled', 'buttonsPrimaryHover', 'buttonsSecondaryDefault', 'buttonsSecondaryDisabled', 'buttonsSecondaryHover', 'captiontextDefaultNone', 'captiontextErrorNone', 'dividerPrimaryNone', 'documentbodyNoneNone', 'iconsPrimaryNone', 'iconsFooterNone', 'inputlabelNoneDisabled', 'inputlabelNoneNone', 'inputtextareasNoneDisabled', 'inputtextareasNoneFocus', 'inputtextareasNoneNone', 'inputtextinputsNoneDisabled', 'inputtextinputsNoneFocus', 'inputtextinputsNoneNone', 'inputtextinputsNoneError', 'headersSmallNone', 'headersMediumNone', 'headersSemibigNone', 'linksNoneDefault', 'linksNoneHover', 'linksLegalDefault', 'linksLegalHover', 'panelcontainerNoneActive', 'panelcontainerNoneHover', 'panelcontainerNoneNone', 'narvarfooterNoneNone', 'selecteditemNoneNone', 'spinnerPrimaryNone']
}), {
  translationKeys: ['claimsOrderLookupReasonDescription', 'claimsOrderLookupReasonLabel', 'claimsOrderLookupReasonOptionItemDamaged', 'claimsOrderLookupReasonOptionItemMissing', 'claimsOrderLookupReasonOptionMissingPackage', 'claimsOrderLookupReasonOptionWrongItem', 'claimsOrderLookupReasonOptionWrongItemHelperText', 'claimsOrderLookupReasonRequired', 'claimsReasonItemDamaged', 'claimsReasonItemMissing', 'claimsReasonLabel', 'claimsReasonPackageMissing', 'claimsReasonWrongItem']
});

exports["default"] = PrefetchData$1;
